import { lazy } from "react";
const GiftSubscription = lazy(() => import("../components/subscriptions.gift"));
const SubscriptionsSolo = lazy(
  () => import("../components/subscriptions.solo"),
);
const SubscriptionsDouble = lazy(
  () => import("../components/subscriptions.double"),
);
const SubscriptionsFamily = lazy(
  () => import("../components/subscriptions.family"),
);
const SubscriptionReputation = lazy(
  () => import("../components/subscription.reputation"),
);

const subscriptionsRoutes = [
  {
    path: "/subscriptions/solo",
    component: SubscriptionsSolo,
    title: "Solo Subscription Plans | Delete My Info",
    description:
      "Explore our solo subscription plans tailored to individuals. Choose the plan that fits your needs and enjoy exclusive benefits.",
  },
  {
    path: "/subscriptions/double",
    component: SubscriptionsDouble,
    title: "Double Subscription Plans | Delete My Info",
    description:
      "Check out our double subscription plans for pairs or couples. Enjoy joint benefits and discounts with ease.",
  },
  {
    path: "/subscriptions/family",
    component: SubscriptionsFamily,
    title: "Family Subscription Plans | Delete My Info",
    description:
      "Discover our family subscription plans designed for multiple users. Enjoy shared benefits and savings for your family.",
  },
  {
    path: "/subscriptions/solo/trial",
    component: SubscriptionsSolo,
    title: "Solo Subscription Trial | Free Trial | Delete My Info",
    description:
      "Start your free trial of our solo subscription plan. Experience the benefits firsthand with no commitment.",
  },
  {
    path: "/subscriptions/double/trial",
    component: SubscriptionsDouble,
    title: "Double Subscription Trial | Free Trial | Delete My Info",
    description:
      "Start your free trial of our double subscription plan. Enjoy joint benefits with no commitment.",
  },
  {
    path: "/subscriptions/family/trial",
    component: SubscriptionsFamily,
    title: "Family Subscription Trial | Free Trial | Delete My Info",
    description:
      "Start your free trial of our family subscription plan. Experience shared benefits with no obligation.",
  },
  {
    path: "/subscriptions/gift",
    component: GiftSubscription,
    title: "Subscription Gift Ideas | Gift a Subscription | Delete My Info",
    description:
      "Explore subscription gift ideas. Give the gift of [product/service] with our easy gifting options.",
  },
  {
    path: "/subscriptions/reputation/standard/annually",
    component: SubscriptionReputation,
    title: "Standard Subscription | Annual Plan | Delete My Info",
    description:
      "Subscribe annually to our standard reputation plan. Enjoy [features/benefits] with our reliable service.",
  },
  {
    path: "/subscriptions/reputation/standard/monthly",
    component: SubscriptionReputation,
    title: "Standard Subscription | Monthly Plan | Delete My Info",
    description:
      "Subscribe monthly to our standard reputation plan. Enjoy [features/benefits] with flexible payment options.",
  },
  {
    path: "/subscriptions/reputation/plus/annually",
    component: SubscriptionReputation,
    title: "Plus Subscription | Annual Plan | Delete My Info",
    description:
      "Subscribe annually to our standard reputation plan. Enjoy [features/benefits] with our reliable service.",
  },
  {
    path: "/subscriptions/reputation/plus/monthly",
    component: SubscriptionReputation,
    title: "Plus Subscription | Monthly Plan | Delete My Info",
    description:
      "Subscribe monthly to our plus reputation plan. Get [features/benefits] with affordable monthly payments.",
  },
  {
    path: "/subscriptions/reputation/vip/annually",
    component: SubscriptionReputation,
    title: "VIP Subscription | Annual Plan | Delete My Info",
    description:
      "Subscribe annually to our VIP reputation plan. Access exclusive [features/benefits] with premium service.",
  },
  {
    path: "/subscriptions/reputation/vip/monthly",
    component: SubscriptionReputation,
    title: "VIP Subscription | Monthly Plan | Delete My Info",
    description:
      "Subscribe monthly to our VIP reputation plan. Access premium [features/benefits] with monthly convenience.",
  },
  {
    path: "/subscriptions/reputation/vipelite/annually",
    component: SubscriptionReputation,
    title: "VIP Elite Subscription | Annual Plan | Delete My Info",
    description:
      "Subscribe annually to our VIP Elite reputation plan. Enjoy top-tier [features/benefits] with exclusive perks.",
  },
  {
    path: "/subscriptions/reputation/vipelite/monthly",
    component: SubscriptionReputation,
    title: "VIP Elite Subscription | Monthly Plan | Delete My Info",
    description:
      "Subscribe monthly to our VIP Elite reputation plan. Enjoy exclusive [features/benefits] with flexible monthly payments.",
  },
];
export default subscriptionsRoutes;
